module.exports = __webpack_public_path__ + "img/icon-wishlist-filled-2.bf2a26d.svg";